
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1608442411126",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "4738",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 590.667c-140 0-250-110-250-250s109.999-250 250-250 250 110 250 250-109.999 250-250 250z m0-50.001c110 0 200-90 200-200s-90-200-200-200-200 90-200 200 90 200.002 200 200.002z",
        "p-id": "4739"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M112 940.667c0-220 180-400 400-400s400 180 400 400h-50c0-195-155-350-350-350s-350 155-350 350h-50z",
        "p-id": "4740"
      }
    }
  ]
})
    }
  